const dblinking = { label: "DB Linking", value: "DBLinking" };
const customaction = { label: "Custom Action", value: "CustomAction" };
const webservice = { label: "Web Service", value: "WebService" };
const customservice = { label: "Custom Service", value: "CustomWebService" };
const command = { label: "Command", value: "Command" };

export const EventListjson = {
  textbox: {
    controls: [
      {
        label: "KeyDown",
        value:"KeyDown",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Lost Focus",
        value:"LostFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F1",
        value:"KeyPressF1",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F2",
        value:"KeyPressF2",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F3",
        value:"KeyPressF3",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F4",
        value:"KeyPressF4",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  button: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking,command, customaction, webservice, customservice],
      },
    ],
  },
  textarea: {
    controls: [
      {
        label: "KeyDown",
        value:"KeyDown",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Lost Focus",
        value:"LostFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F1",
        value:"KeyPressF1",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F2",
        value:"KeyPressF2",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F3",
        value:"KeyPressF3",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "F4",
        value:"KeyPressF4",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  datepick: {
    controls: [
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Lost Focus",
        value:"LostFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  combo: {
    controls: [
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking,  customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  listbox: {
    controls: [
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice],
      },
      {
        label: "On Lost Focus",
        value:"LostFocus",
        events: [dblinking, customaction, webservice],
      },
    ],
  },
  checkbox: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  radio: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },

  frame: {
    controls: [
      {
        label: "On Load",
        value:"load",
        events: [dblinking, customaction,webservice,customservice],
      },
    ],
  },
  form: {
    controls: [
      {
        label: "On Load",
        value:"load",
        events: [dblinking, customaction],
      },
    ],
  },
  toggle: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  slider: {
    controls: [
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  tile: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking,command,customaction, webservice, customservice],
      },
    ],
  },
  // CustomControl: {
  //   controls: [
  //     {
  //       label: "On Click",
  //       value:"Click",
  //       events: [dblinking,command,customaction, webservice, customservice],
  //     },
  //   ],
  // },
  doclist: {
    controls: [
      {
        label: "On Upload",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Remove",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  image: {
    controls: [
      {
        label: "On Click",
        value:"Click",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  richtext: {
    controls: [
      {
        label: "KeyDown",
        value:"KeyDown",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Focus",
        value:"GotFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Lost Focus",
        value:"LostFocus",
        events: [dblinking, customaction, webservice, customservice],
      },
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  picklist: {
    controls: [
      {
        label: "On Change",
        value:"Change",
        events: [dblinking, customaction, webservice, customservice],
      },
    ],
  },
  report: {
    controls: [
      {
        label: "On Load",
        value:"load",
        events: [dblinking, customaction],
      },
    ],
  },
  iframe: {
    controls: [
      {
        label: "On Load",
        value:"load",
        events: [dblinking, customaction],
      },
    ],
  },
};
